import type { RichTranslationValues, TranslationValues } from "next-intl";

export function valuesWithAppName<
  T extends TranslationValues | RichTranslationValues,
>(t: any, values?: T): T {
  return {
    ...values,
    appName: t("common.name") as string,
  } as any;
}
